import { LitElement, html, css } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import '@shoelace-style/shoelace/dist/components/card/card.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import SlInput from '@shoelace-style/shoelace/dist/components/input/input.js';

@customElement('vxc-input')
export class TInput extends LitElement {

    static styles = css`
        :host {
            display: block;
            width: 100%;
            height: 100%;
            --border-radius: 5px;
            --sl-input-label-font-size-medium: .7rem;
            --sl-input-focus-ring-color: black;
            --sl-focus-ring-style: solid;
            --sl-focus-ring-width: 1px;
            --sl-input-border-width: 1px;
            --sl-input-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
            --sl-input-focus-ring-offset: 0px;
        }

        sl-card {
            margin: 0px;
            padding: 0px;
            width: 100%;
            height: 100%;
        }

        .title {
            font-weight: 600;
            font-size: .7rem;
            width: 100%;
        }

        .description {
            font-weight: 400;
            font-size: .7rem;
        }

        sl-card::part(base) {
            height: 100%;
            width: 100%;
        }

        sl-card.no-border::part(base) {
            border: none;
            box-shadow: none;
        }

        sl-input {
            margin-top: 0;
            padding-top: 0;
        }

    `
    @property({type: Boolean                 }) border = false
    @property({type: String                  }) title = ''
    @property({type: String                  }) description = ''
    @property({type: String                  }) label = ''
    @property({type: String                  }) name = 'input'
    @property({type: String                  }) type = 'text'
    @property({type: String                  }) size = 'medium'
    @property({type: String                  }) value = ''
    @property({type: String                  }) placeholder = ''
    @property({type: String                  }) helptext = ''
    @property({type: String                  }) pattern = ''
    @property({ type: Number                 }) minlength?: number
    @property({ type: Number                 }) maxlength?: number
    @property({ type: Number                 }) min?: number
    @property({ type: Number                 }) max?: number
    @property({ type: String                 }) autocorrects: string = 'off'
    @property({ type: Boolean                }) spellcheck: boolean = false
    @property({ type: String                 }) inputmode: string = 'text'       // 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url'
    @property({ type: Boolean, reflect: true }) clearable: boolean = false
    @property({ type: Boolean, reflect: true }) noSpinButtons: boolean = false
    @property({ type: Boolean, reflect: true }) passwordToggle: boolean = false
    @property({ type: Boolean, reflect: true }) disabled: boolean = false
    @property({ type: Boolean, reflect: true }) readonly: boolean = false
    @property({ type: Boolean, reflect: true }) required: boolean = false   
    @query('sl-input') slInput!:SlInput

    private onValue(event: Event) {
        const slInput = event.target as any
        this.value = slInput.value
        this.dispatchEvent(new CustomEvent('valueUpdated', { detail: { value: this.value } }));
    }

    public isValid() : boolean {
        return this.slInput?.reportValidity() || false
    }

    render() {
        console.log('this.border :', this.border)
        return html`
        <sl-card class=${this.border ? '' : 'no-border'}>
            <div class="title">${this.title}</div>
            <!--div class="description">${this.description}</div-->
            <sl-input 
                id="input"
                name=${this.name} 
                label=${this.label}
                size=${this.size}
                value=${this.value} 
                ${this.pattern? html`minlength=${this.pattern}` : ''}
                ${this.minlength? html`minlength=${this.minlength}` : ''}
                ${this.maxlength? html`minlength=${this.maxlength}` : ''}
                ${this.min? html`minlength=${this.min}` : ''}
                ${this.max? html`minlength=${this.max}` : ''}
                autocorrect=${this.autocorrects}
                spellcheck=${this.spellcheck}
                inputmode=${this.inputmode}
                placeholder=${this.placeholder} 
                helpText=${this.helptext}
                clearable=${this.clearable} 
                noSpinButtons=${this.noSpinButtons}
                ?disabled=${this.disabled}
                ?readonly=${this.readonly}
                ?required=${this.required}
                passwordToggle=${this.passwordToggle}
                @sl-input=${this.onValue}
            ></sl-input>
        </sl-card>
        `
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-input': TInput
  }
}